module.exports = __webpack_public_path__ + "static/media/f2.baae6460.png";